import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { epicsErrorHandler } from '../../../epics'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC, PAGINATE_CHANGE, SEARCH_CHANGE } from './constants'

const fetchDataEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      SEARCH_CHANGE,
      PAGINATE_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.incidents.incidents)
      return true
    }),
    mergeMap((action) =>
      api.resolutionCenter
        .getServerScanData(
          action.payload.reportId,
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) => fetchDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
          takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchDataEpic)
